<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-app id="inspire" class="grey lighten-4">

        <Toolbar/>

        <v-content>
            <v-container fill-height>
                <v-layout column>
                    <transition
                            mode="out-in"
                            :name="transitionName"
                    >
                        <router-view :key="$route.fullPath"></router-view>
                    </transition>
                </v-layout>
            </v-container>
        </v-content>
        <v-btn
                fab
                bottom
                right
                color="pink"
                dark
                fixed
                v-show="false"
                @click="createStudentDialog = !createStudentDialog"
        >
            <v-icon>add</v-icon>
        </v-btn>
        <v-dialog v-model="createStudentDialog" width="800px">
            <v-card>
                <v-card-title
                        class="grey lighten-4 py-4 title"
                >
                    Create contact
                </v-card-title>
                <v-container grid-list-sm class="pa-4">
                    <v-layout row wrap>
                        <v-flex xs12 align-center justify-space-between>
                            <v-layout align-center>
                                <v-avatar size="40px" class="mr-3">
                                    <img
                                            src="//ssl.gstatic.com/s2/oz/images/sge/grey_silhouette.png"
                                            alt=""
                                    >
                                </v-avatar>
                                <v-text-field
                                        placeholder="Name"
                                ></v-text-field>
                            </v-layout>
                        </v-flex>
                        <v-flex xs6>
                            <v-text-field
                                    prepend-icon="business"
                                    placeholder="Company"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs6>
                            <v-text-field
                                    placeholder="Job title"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field
                                    prepend-icon="mail"
                                    placeholder="Email"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field
                                    type="tel"
                                    prepend-icon="phone"
                                    placeholder="(000) 000 - 0000"
                                    mask="phone"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field
                                    prepend-icon="notes"
                                    placeholder="Notes"
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                </v-container>
                <v-card-actions>
                    <v-btn flat color="primary">More</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="createStudentDialog = false">Cancel</v-btn>
                    <v-btn flat @click="createStudentDialog = false">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-app>
</template>

<script>
    import Toolbar from '@/components/Toolbar.vue'

    export default {
        name: "MainLayout.vue",
        components: {"Toolbar": Toolbar},
        data: () => ({
            createStudentDialog: false,
            transitionName: 'slide-left'
        }),
        methods: {
            startsWithSameElement(ar1, ar2) {
                let cleanedAr1 = ar1.filter(s => s.length > 0);
                let cleanedAr2 = ar2.filter(s => s.length > 0);
                if (cleanedAr1.length == 0 || cleanedAr2.length == 0) {
                    return false;
                }
                return cleanedAr1[0] === cleanedAr2[0]; // comparing just the first element will give us the answer, no need to compare others
            }
        },
        watch: {
            '$route' (to, from) {
                const toDepth = to.path.split('/');
                const fromDepth = from.path.split('/');
                if (this.startsWithSameElement(toDepth, fromDepth)) {
                    this.transitionName = toDepth.length < fromDepth.length ? 'slide-right' : 'slide-left';
                }
                else {
                    this.transitionName = 'fade'
                }
            }
        }
    }
</script>



<style >
    .slide-right-leave-active,
    .slide-right-enter-active,
    .slide-left-leave-active,
    .slide-left-enter-active {
        transition: 100ms ease-in;
    }
    .slide-right-enter {
        transform: translate(-100%, 0);
    }
    .slide-right-leave-to {
        transform: translate(100%, 0);
    }

    .slide-left-enter {
        transform: translate(100%, 0);
    }
    .slide-left-leave-to {
        transform: translate(-100%, 0);
    }

    .fade-enter, .fade-leave-to {
        opacity: 0;
    }

    .fade-enter-active, .fade-leave-active{
        transition: all 250ms ease-in;
    }
</style>
